/**
 * Add item to cart based on variant ID
 * @param {Array} items
 * @returns {object} cart
 */
const addToCart = async (items) => {
  const formData = {
    items,
    sections: 'header,cart-drawer,main-cart,footer',
  };
  try {
    const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData),
    });

    const parsedResponse = await response.json();

    if (parsedResponse.sections) {
      const { header, 'cart-drawer': cartDrawer } = parsedResponse.sections;
      // update cart
      updateCartDrawerContent(cartDrawer);
    } else {
      // process the error and show it to the user
      document.dispatchEvent(new CustomEvent('cart:open'));
      const event = new CustomEvent('cart:error', {
        detail: parsedResponse.description || parsedResponse.message,
      });
      document.dispatchEvent(event);
    }
  } catch (error) {
    console.error('Error:', error);
  }
};

/**
 * Get cart content when we need the cart content without adding, updating or deleting items
 * @param {function} callback
 * @returns {object} cart
 */

const getCart = async () => {
  try {
    const response = await fetch(
      window.Shopify.routes.root +
        '?sections=header,cart-drawer,main-cart,footer',
      {
        method: 'GET',
        cache: 'no-cache',
        headers: {
          'Content-Type': 'application/json',
        },
      }
    );

    const parsedResponse = await response.json();

    if (parsedResponse) {
      const { header, 'cart-drawer': cartDrawer } = parsedResponse;
      // update cart
      updateCartDrawerContent(cartDrawer);
    } else {
      // process the error and show it to the user
      document.dispatchEvent(new CustomEvent('cart:open'));
      const event = new CustomEvent('cart:error', {
        detail: parsedResponse.description || parsedResponse.message,
      });
      document.dispatchEvent(event);
    }
    document.dispatchEvent(new CustomEvent('cart:open'));
  } catch (error) {
    console.error('Error:', error);
  }
};

/**
 * Change cart item
 * @param {string} key - can either be line item key or variant ID
 * @param {number} quantity
 * @param {function} callback
 * @returns {object} cart
 */
const changeItem = ({ key, quantity, properties, callback }) =>
  new Promise((resolve) => {
    const formData = {
      id: key,
      quantity,
      properties,
      sections: 'header,cart-drawer,footer',
    };

    fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData),
    })
      .then((response) => response.json())
      .then(async (cart) => {
        if (cart.sections) {
          const { header, 'cart-drawer': cartDrawer } = cart.sections;

          // update cart count
          updateCartDrawerContent(cartDrawer);
        } else {
          // process the error and show it to the user
          const event = new CustomEvent('cart:error', {
            detail: cart.description || cart.message,
          });
          document.dispatchEvent(event);
        }
        return {
          response: cart,
        };
      })
      .then(({ response }) => {
        const failedIncrease = response.status === 422 ? key : null;

        if (callback) {
          callback(response);
        }

        resolve(response);
      });
  });

const updateCartDrawerContent = (cartDrawer) => {
  const parser = new DOMParser();
  const cartDrawerElement = parser.parseFromString(cartDrawer, 'text/html');

  const cartDrawerCount = document.querySelectorAll('[data-cart-count]');
  if (cartDrawerCount) {
    const temp = cartDrawerElement.querySelector(
      '[data-cart-drawer-count-number]'
    ).textContent;

    const currentCartCount = document.querySelector(
      '[data-cart-drawer-count-number]'
    );

    if (currentCartCount) {
      currentCartCount.textContent = temp;
    }

    cartDrawerCount.forEach((item) => {
      const tempNumber = temp ? temp.replace('(', '').replace(')', '') : '';
      item.textContent = tempNumber;
      if (tempNumber > 0) {
        item.classList.remove('hidden');
      } else {
        item.classList.add('hidden');
      }
    });
  }

  // update cart content
  const cartDrawerContent = document.querySelector(
    '[data-cart-drawer-content]'
  );
  if (cartDrawerContent) {
    cartDrawerContent.innerHTML = cartDrawerElement.querySelector(
      '[data-cart-drawer-content]'
    ).innerHTML;
  }

  // update cart footer
  const cartDrawerFooter = document.querySelector('[data-cart-drawer-footer]');
  if (cartDrawerFooter) {
    cartDrawerFooter.innerHTML = cartDrawerElement.querySelector(
      '[data-cart-drawer-footer]'
    ).innerHTML;
  }

  // update shipping progress
  const cartDrawerFreeShipping = document.querySelector(
    '[data-cart-drawer-free-shipping]'
  );
  if (cartDrawerFreeShipping) {
    cartDrawerFreeShipping.innerHTML = cartDrawerElement.querySelector(
      '[data-cart-drawer-free-shipping]'
    ).innerHTML;
    cartDrawerFreeShipping.classList = cartDrawerElement.querySelector(
      '[data-cart-drawer-free-shipping]'
    ).classList;
  }
  // Emit custom event to reattach event listeners
  const event = new CustomEvent('cart:attachListener');
  document.dispatchEvent(event);
};

export { addToCart, changeItem, getCart };
